/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Container } from 'react-bootstrap';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import sortFunc from '../../../utils/ordernarColunaInt';
import moment from 'moment-timezone';
import sortFuncDate from '../../../utils/ordernarColunaDate';
import { useSelector } from 'react-redux';
import Toggle from 'react-bootstrap-toggle';
import { toast } from 'react-toastify';
import ModalExcluir from './ModalExcluir/index';
import api from '../../../services/API';
import ModalEditar from './ModalEditar/index';


export default function Redes() {
  const usuario = useSelector((state) => {
    return state.usuario;
  });

  const columns = [
    {
      dataField: 'id',
      text: 'ID',
      sort: false,
      hidden: true,
    },
    {
      dataField: 'nome',
      text: 'Rede',
      sort: true,
    },
    {
      dataField: 'regiao',
      text: 'Região',
      sort: true,
    },
    {
      dataField: 'valorPonto',
      text: 'Valor Ponto',
      sort: true,
      sortFunc: sortFunc,
      formatter: (celula, valor) => {
        return Number(valor.valorPonto)
          .toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
          .toString()
          .replace(/\u00a0/g, ' ');
      },
      hidden: [1, 2].includes(usuario.permissao) ? false : true,
    },
    {
      dataField: 'numeroRevendas',
      text: 'Nº Lojas',
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'numeroParceiros',
      text: 'Nº Vendedores Lojas',
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'totalVendas',
      text: 'Total Vendas',
      formatter: (celula, valor) => {
        return Number(valor.totalVendas)
          .toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
          .toString()
          .replace(/\u00a0/g, ' ');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'totalCusto',
      text: 'Total Custo',
      formatter: (celula, valor) => {
        return Number(valor.totalCusto)
          .toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
          .toString()
          .replace(/\u00a0/g, ' ');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'saldoTotal',
      text: 'Pontuação Total',
      formatter: (celula, valor) => {
        return Number(valor.totalPontos).toLocaleString('pt-BR');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'saldoPontos',
      text: 'Saldo de Pontos',
      formatter: (celula, valor) => {
        return Number(valor.saldoPontos).toLocaleString('pt-BR');
      },
      sort: true,
      sortFunc: sortFunc,
    },
    {
      dataField: 'ultimaPontuacao',
      text: 'Última Pontuação',
      formatter: (celula, valor) => {
        return valor.ultimaPontuacao && valor.ultimaPontuacao !== 0
          ? moment(valor.ultimaPontuacao).format('DD/MM/YYYY HH:mm:ss')
          : '-';
      },
      sort: true,
      sortFunc: sortFuncDate,
    },
    {
      isDummyField: true,
      dataField: 'ativo',
      text: 'Ativo',
      sort: true,
      hidden: [2].includes(usuario.permissao) ? false : true,
      formatter: (celula, valor) => {
        return (
          <Toggle
            onClick={(state) => updateStatus(state, valor.id)}
            on={<span>Sim</span>}
            off={<span>Não</span>}
            size="sm"
            offstyle="danger"
            active={valor.ativo === 1 ? true : false}
          />
        );
      },
    },
    {
      dataField: 'editar',
      isDummyField: true,
      text: 'Editar',
      sort: false,
      hidden: [1, 2].includes(usuario.permissao) ? false : true,
      formatter: (celula, valor) => (
        <button
          className="btn-limpo f-12 p-1"
          onClick={() => {
            abrirModalEditar(valor.id);
          }}
        >
          <i className="fas fa-edit"></i>
        </button>
      ),
    },
    {
      dataField: 'apagar',
      isDummyField: true,
      text: 'Apagar',
      sort: false,
      hidden: [2].includes(usuario.permissao) ? false : true,
      formatter: (celula, valor) => (
        <button
          className="btn-limpo f-12 p-1"
          onClick={() => {
            abrirModalExcluir(valor.id, valor.nome);
          }}
        >
          <i className="fas fa-trash f-red"></i>
        </button>
      ),
    },
  ];

  const defaultSorted = [
    {
      dataField: 'nome',
      order: 'asc',
      sort: true,
    },
  ];

  const [data, setData] = useState([]);
  const [dataEditar, setDataEditar] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [pagination, setPagination] = useState({
    nextCursor: null,
    prevCursor: null,
    hasNext: false,
    hasPrev: false,
    limit: 10,
    totalCount: 0,
    currentPage: 1,
  });
  const [id, setId] = useState('');
  const [rede, setRede] = useState('');
  const [mostrarModalExcluir, setMostrarModalExcluir] = useState(false);
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false);
  const [searchText, setSearchText] = useState('');

  const handleTableChange = (type, { page, sizePerPage }) => {
    if (type === 'pagination') {
      const currentPage = page || 1;
      const newLimit = sizePerPage || pagination.limit;
      
      if (newLimit !== pagination.limit) {
        setPagination(prev => ({ 
          ...prev, 
          limit: newLimit, 
          currentPage: 1,
          nextCursor: null,
          prevCursor: null,
          hasNext: false,
          hasPrev: false,
        }));
        buscarRedes(null, 'next', newLimit, searchText);
        return;
      }

      if (currentPage === 1) {
        setPagination(prev => ({ 
          ...prev, 
          currentPage: 1,
          nextCursor: null,
          prevCursor: null,
          hasNext: false,
          hasPrev: false,
        }));
        buscarRedes(null, 'next', pagination.limit, searchText);
      } else {
        const direction = currentPage > pagination.currentPage ? 'next' : 'prev';
        const cursor = direction === 'next' ? pagination.nextCursor : pagination.prevCursor;
        if (cursor) {
          setPagination(prev => ({ ...prev, currentPage }));
          buscarRedes(cursor, direction, pagination.limit, searchText);
        } else {
          setPagination(prev => ({ ...prev, currentPage: prev.currentPage }));
        }
      }
    }
  };

  const options = {
    page: pagination.currentPage,
    sizePerPage: pagination.limit,
    totalSize: pagination.totalCount,
    showTotal: true,
    sizePerPageList: [
      {
        text: '10',
        value: 10,
      },
      {
        text: '50',
        value: 50,
      },
      {
        text: '100',
        value: 100,
      },
    ],
    paginationTotalRenderer: (from, to, size) =>
      pagination.totalCount > 0 ? (
        <span className="react-bootstrap-table-pagination-total px-2">
          {from}-{to} de {pagination.totalCount} resultados
        </span>
      ) : (
        <span className="react-bootstrap-table-pagination-total px-2">
          Nenhum resultado
        </span>
      ),
    onPageChange: (page, sizePerPage) => {
      handleTableChange('pagination', { page, sizePerPage });
    },
    onSizePerPageChange: (page, sizePerPage) => {
      handleTableChange('pagination', { page: 1, sizePerPage });
    },
  };

  useEffect(() => {
    buscarRedes(null, 'next', pagination.limit);
  }, []);

  useEffect(() => {
    if (buscando) {
      setData([]);
    }
  }, [buscando]);

  const buscarRedes = async (cursor = null, direction = 'next', limitParaUsar = null, search = '') => {
    setBuscando(true);

    let params = {
      completo: 1,
      limit: limitParaUsar || pagination.limit,
    };
    if (usuario.permissao !== 2) {
      params.ativo = 1;
    }
    if (search) {
      params.search = search;
    }
    if (!cursor) {
      params.includeCount = 'true';
    }
    if (cursor) {
      params.cursor = cursor;
      params.direction = direction;
    }
    const searchParams = new URLSearchParams(params);

    const resultado = await api.get(`/api/redes?${searchParams.toString()}`);
    if (resultado) {
      setData(resultado.data.redes);
      if (resultado.data.pagination) {
        setPagination(prev => ({
          nextCursor: resultado.data.pagination.nextCursor || null,
          prevCursor: resultado.data.pagination.prevCursor || null,
          hasNext: resultado.data.pagination.hasNext || false,
          hasPrev: resultado.data.pagination.hasPrev || false,
          limit: resultado.data.pagination.limit || prev.limit,
          totalCount: resultado.data.pagination.totalCount !== null && resultado.data.pagination.totalCount !== undefined 
            ? resultado.data.pagination.totalCount 
            : prev.totalCount,
          currentPage: prev.currentPage,
        }));
      }
    }
    setBuscando(false);
  };

  async function updateStatus(state, id) {
    const resultado = await api.put(`/api/redes/${id}`, {
      ativo: state ? 1 : 0,
    });

    if (resultado) {
      toast.success('Rede atualizada com sucesso', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
      });
    }

    setData(
      data.map((d) => {
        if (d.id === id) {
          d.ativo = state ? 1 : 0;
        }
        return d;
      })
    );
  }

  const abrirModalExcluir = (id, rede) => {
    setRede(rede);
    setId(id);
    setMostrarModalExcluir(true);
  };

  const fecharModalExcluir = () => {
    setRede('');
    setId('');
    setMostrarModalExcluir(false);
  };

  const abrirModalEditar = (id) => {
    const dados = data.filter((d) => d.id === id);
    setDataEditar(dados[0]);
    setMostrarModalEditar(true);
  };

  const fecharModalEditar = () => {
    setDataEditar([]);
    setMostrarModalEditar(false);
  };

  const atualizarExclusao = (id) => {
    setData(data.filter((d) => d.id !== id));
  };

  const atualizarRede = (dataUpdated) => {
    setData(
      data.map((d) => {
        if (d.id === dataUpdated.id) {
          d = { ...d, ...dataUpdated };
        }
        return d;
      })
    );
  };

  return (
    <Container fluid>
      <h4 className="pt-3 pb-3 f-black">Redes</h4>
      <hr className="hr-loja mt-0 mb-4" />
      <div>
        <ToolkitProvider
          bootstrap4
          keyField="id"
          data={data}
          columns={columns}
        >
          {(props) => (
            <div>
              <div className="d-flex flex-row-reverse mb-3">
                <div className="d-flex align-items-center" style={{ width: '100%', maxWidth: '400px' }}>
                  <input
                    type="text"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        setPagination(prev => ({ 
                          ...prev, 
                          currentPage: 1,
                          nextCursor: null,
                          prevCursor: null,
                          hasNext: false,
                          hasPrev: false,
                        }));
                        buscarRedes(null, 'next', pagination.limit, searchText);
                      }
                    }}
                    placeholder="Buscar"
                    className="input-theme mr-2"
                    style={{ flex: 1 }}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      setPagination(prev => ({ 
                        ...prev, 
                        currentPage: 1,
                        nextCursor: null,
                        prevCursor: null,
                        hasNext: false,
                        hasPrev: false,
                      }));
                      buscarRedes(null, 'next', pagination.limit, searchText);
                    }}
                    className="btn-busca"
                    style={{ marginBottom: 0, marginTop: 0, flexShrink: 0 }}
                  >
                    {buscando ? (
                      <i className="fas fa-circle-notch fa-spin"></i>
                    ) : (
                      <i className="fas fa-search"></i>
                    )}
                  </button>
                </div>
              </div>
              <BootstrapTable
                noDataIndication={() =>
                  buscando ? (
                    <span>
                      Carregando
                      <i className="fas fa-circle-notch fa-spin ml-3"></i>
                    </span>
                  ) : (
                    <span>Sem resultados</span>
                  )
                }
                classes="table-dark text-center rounded"
                wrapperClasses="rounded"
                bordered={false}
                pagination={paginationFactory(options)}
                remote={{ pagination: true }}
                onTableChange={handleTableChange}
                defaultSorted={defaultSorted}
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
      <ModalExcluir
        show={mostrarModalExcluir}
        onHide={fecharModalExcluir}
        rede={rede}
        id={id}
        atualizarExclusao={atualizarExclusao}
      />
      <ModalEditar
        show={mostrarModalEditar}
        onHide={fecharModalEditar}
        data={dataEditar}
        atualizarRede={atualizarRede}
      />
    </Container>
  );
}
